/*eslint-disable */
const $ = window.jQuery = require('jquery');

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import allCountries from './phoneCodeList.json';
import countries from '@/services/country.json';
import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';

// You need a specific loader for CSS files


export default {
  name: 'interview-add',
  components: {
    Multiselect,
    datetime: Datetime,
  },
  props: [],
  data () {
    return {
      submitted:false,
      fullName:'',
      email:'',
      phone: {
        number: '',
        isValid: false,
        countryIso: 'in',
        countryCode:'91'
      },
      allCountriesList:[],
      countryList:[],
      interview_date:'',
      file:null,
      uploadAttachmentName:'',
      comment:'',
      userList:null,
      userListResults:[],
      options:[],
      users:[],
      sentUserData:[],
      minDatetime:new Date().toISOString(),
    }
  },
  computed: {
  },
  mounted () {
    this.$store.dispatch('getInterviewerListFun').then((res) => {
      this.userList = res.data.data
      if(this.userList){
        this.userListResults = this.userList.results
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    })
    this.getUserCountry();
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.option-list');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
  },
  methods: {
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.sentUserData = []
          for(var i = 0; i < this.users.length; i++){
            this.sentUserData.push(this.users[i].id)
          }
          var formData = new FormData();
          formData.append('name', this.fullName);
          formData.append('email', this.email);
          formData.append('interview_date', this.interview_date);
          formData.append('resume', this.file);
          formData.append('file_name', this.uploadAttachmentName);
          formData.append('mobile_country_code', '+' + this.phone.countryCode);
          formData.append('mobile', this.phone.number);
          formData.append('interviewer_id', this.sentUserData);
          formData.append('round_1', true);
          formData.append('round_1_datetime', this.interview_date);
          this.$store.dispatch('createInterviewInfoFun', formData)
            .then((res) => {  
                this.submitted = false;
                toast.success(res.data.msg);            
                this.$router.push({ name: 'employeeList'})
                // this.$router.push({ name: 'employeeInterviewList'})
            }).catch((err) => {
                this.submitted = false;
                toast.error(err.data.user_msg || err.data.msg);
            })
            return;
        }
      });
    },
    clearUploadedFileForModelTrainerMethod(){
      this.file = null
      this.uploadAttachmentName = ''
      this.$validator.reset()
    },
    handleAttachmentUpload(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }else {
        this.uploadAttachmentName = '';
      }
    },
  },
  watch:{
  }
}